import { supabase } from '$lib/supabase';

export function generateTags(title: string, channelName: string): string[] {
    const tags: string[] = [];
    const tagCounts: { [key: string]: number } = {};

    // タイトルの最後の角括弧とその内容を除去
    const titleWithoutLastBracket = title.replace(/【[^【】]*】\s*$/, '');

    // 残った角括弧内のコンテンツを抽出
    const bracketContent = [...titleWithoutLastBracket.matchAll(/【([^】]+)】/g)].map(match => match[1]);

    bracketContent.forEach(content => {
        const mainTitle = content.trim();
        
        // すべての括弧内のコンテンツをタグとして追加
        if (mainTitle.length > 0) {
            tags.push(mainTitle);
        }
    });

    // タグの出現回数をカウント
    tags.forEach(tag => {
        const normalizedTag = tag.toLowerCase().replace(/[^a-z0-9ぁ-んァ-ン]/g, '');
        tagCounts[normalizedTag] = (tagCounts[normalizedTag] || 0) + 1;
    });

    // フィルタリング後のタグ
    const filteredTags = Object.entries(tagCounts)
        .filter(([_, count]) => count >= 1)
        .map(([tag]) => tags.find(t => t.toLowerCase().replace(/[^a-z0-9ぁ-んァ-ン]/g, '') === tag))
        .filter((tag): tag is string => tag !== undefined);

    // 所属名のリスト
    const affiliations = [channelName];

    // チャンネル名との比較関数
    function isSubstringOfLength3OrMore(str1: string, str2: string): boolean {
        const len1 = str1.length;
        const len2 = str2.length;
        for (let i = 0; i < len1 - 2; i++) {
            const substr = str1.slice(i, i + 3);
            if (str2.includes(substr)) {
                return true;
            }
        }
        return false;
    }

    // 所属名との比較とチャンネル名との3文字以上の一致チェック
    const finalTags = filteredTags.filter(tag => {
        if (tag) {
            const normalizedTag = tag.toLowerCase();
            const normalizedChannelName = channelName.toLowerCase();
            return !affiliations.some(affiliation => 
                normalizedTag.includes(affiliation.toLowerCase())
            ) && !isSubstringOfLength3OrMore(normalizedTag, normalizedChannelName)
              && !isSubstringOfLength3OrMore(normalizedChannelName, normalizedTag);
        }
        return false;
    });

    return [...new Set(finalTags)];
}
